export { type FsrsCardReviewLog, fsrsCardReviewLogTable } from "#fsrs-card-review-log-table";
